import {
  ApiOnboardingType,
  ApiProject,
  ApiSimpleOnboarding,
} from "@incendium/api";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import CustomDialog from "Components/CustomDialog/CustomDialog";
import { GenericDialoagProps } from "Interfaces";
import { useCallback, useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { AllProjectsSelector } from "features/project";

interface INewOnboardingDialogProps extends GenericDialoagProps {
  onSave: (v: ApiSimpleOnboarding) => void;
  onboardingItems: ApiSimpleOnboarding[];
}

function NewOnboardingDialog({
  open,
  setOpen,
  onSave,
  onboardingItems,
}: INewOnboardingDialogProps) {
  const [projectSelection, setProjectSelection] = useState<ApiProject | null>(
    null,
  );
  const [onboardingType, setOnboardingType] = useState<ApiOnboardingType>(
    ApiOnboardingType.ONBOARDING_TYPE_UNKNOWN,
  );
  const onClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const onSubmit = useCallback(() => {
    if (!projectSelection) {
      return;
    }
    onSave({
      projectId: projectSelection.id,
      onboardingType: onboardingType,
    });
  }, [projectSelection, onSave, onboardingType]);

  useEffect(() => {
    if (!open) {
      setProjectSelection(null);
    }
  }, [open]);

  const filterFn = useCallback(
    (project) => {
      if (!onboardingItems || onboardingItems.length === 0) {
        return true;
      }
      const idx = onboardingItems.findIndex((o) => o.projectId === project.id);
      return idx < 0;
    },
    [onboardingItems],
  );

  return (
    <CustomDialog onClose={onClose} fullWidth maxWidth="sm" open={open}>
      <ValidatorForm onSubmit={onSubmit}>
        <DialogTitle>Create New Project Onboarding</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <AllProjectsSelector
              project={projectSelection}
              setProject={setProjectSelection}
              variant="outlined"
              size="medium"
              filterFn={filterFn}
            />
            <TextField
              fullWidth
              label="Onboarding Type"
              name="onboardingType"
              select
              value={
                onboardingType || ApiOnboardingType.ONBOARDING_TYPE_UNKNOWN
              }
              onChange={(e) =>
                setOnboardingType(e.target.value as ApiOnboardingType)
              }
            >
              <MenuItem value={ApiOnboardingType.ONBOARDING_TYPE_UNKNOWN}>
                General
              </MenuItem>
              <MenuItem value={ApiOnboardingType.ONBOARDING_TYPE_WOO_COMMERCE}>
                WooCommerce
              </MenuItem>
            </TextField>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Create Onboarding
          </Button>
        </DialogActions>
      </ValidatorForm>
    </CustomDialog>
  );
}

export default NewOnboardingDialog;
